<!-- Local Cancel / OK for a Settings edit layer (EditLayer's "actions" slot): the layer's own
     footer, two flat halves, so they read as part of the panel, not as the dialog's buttons (Sign
     Out / Close stay below) -->

<template>
  <div class="edit-buttons">
    <button
      class="edit-button cancel"
      type="button"
      data-edit-cancel
      :disabled="!canCancel"
      @click="$emit('cancel')">
      Cancel
    </button>
    <button
      class="edit-button ok"
      type="button"
      data-edit-ok
      :disabled="isBusy"
      @click="$emit('ok')">
      {{ isBusy ? "Saving…" : "OK" }}
    </button>
  </div>
</template>

<script setup>
// canCancel: there's something to discard (a changed field, a pending removal); else Cancel shows
// but is disabled, and OK just closes
defineProps({
  isBusy: {type: Boolean, default: false},
  canCancel: {type: Boolean, default: true},
});
defineEmits(["cancel", "ok"]);
</script>

<style scoped>
/* the layer's footer (design: "Dark UI Action Bar States", 2026-10-15): two equal halves split by
   a faint line, labels centred, no borders, fills or shadows; a hovered half lightens */
.edit-buttons {
  display: flex;
}
/* global.css styles every button: reset here (CLAUDE.md § Vue conventions) */
.edit-button {
  appearance: none;
  flex: 1;
  min-width: 0;
  height: 35px;
  margin: 0;
  padding: 0 12px;
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 400;
  color: white;
  cursor: pointer;
  transition: background-color 120ms ease-out, color 120ms ease-out;
}
.edit-button + .edit-button {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.edit-button.cancel {
  color: rgba(255, 255, 255, 0.7);
}
.edit-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.06);
  color: white;
}
.edit-button:disabled {
  color: rgba(255, 255, 255, 0.3);
  cursor: default;
}
/* inside the half: the layer clips what's outside it */
.edit-button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85) !important;
  outline-offset: -4px;
}
@media (prefers-reduced-motion: reduce) {
  .edit-button {
    transition: none;
  }
}
</style>
